import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { WorkflowUpdateInDto } from 'shared/domain/workflow/types';
import type { WorkflowUpdateRequestModel } from '../httpQueue/workflow/requestRunner';

export interface EditWorkflowUseCase {
  execute(
    workflowId: string,
    workflowUpdateDto: WorkflowUpdateInDto,
    projectId: string,
    uniqueId: string
  ): Promise<void>;
}

export class WorkflowEditor implements EditWorkflowUseCase {
  constructor(
    private addRequest: (request: WorkflowUpdateRequestModel) => Promise<unknown>
  ) {}

  async execute(
    workflowId: string,
    workflowUpdateDto: WorkflowUpdateInDto,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('WorkflowEditor.execute', workflowId, workflowUpdateDto);
    const request: WorkflowUpdateRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      url: `/project/${projectId}/workflow/${workflowId}`,
      data: {
        workflowUpdateDto,
        workflowId,
        projectId,
        uniqueId,
      },
      entityType: HttpRequestModelType.workflow,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const workflowEditor = new WorkflowEditor(addRequest);
